import { pgTable, text, unique } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getTimestampWithTimezone,
} from '../common/utils'

export const shortUrls = pgTable(
  'short_urls',
  {
    ...getBaseFields(),
    key: text().notNull(),
    targetUrl: text().notNull(),
    openedAt: getTimestampWithTimezone(),
    expiresAt: getTimestampWithTimezone(),
  },
  (table) => [
    ...getBaseIndexes('short_urls', table),
    unique('short_urls_key_unique').on(table.key),
  ],
)
